export default {
      id: "arrow-usage",
      viewBox: "0 0 41.44 10.96",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#arrow",
      toString: function () {
        return this.url;
      }
    }